const WEEK_DAYS = [
  "domingo",
  "lunes",
  "martes",
  "miércoles",
  "jueves",
  "viernes",
  "sábado",
];

export function deriveExemptionPlace(params = {}) {
  const map = {
    if_origin: "ORIGIN",
    if_destination: "DESTINATION",
    if_zone: "ZONE",
    if_point: "POINT",
  };

  for (const [key, placeType] of Object.entries(map)) {
    if (params[key] != null && params[key] !== "") {
      return { place_type: placeType, place_value: params[key] };
    }
  }

  return { place_type: "", place_value: "" };
}

export function humanizeName(value) {
  if (!value) return "";

  return String(value)
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^\w/, (c) => c.toUpperCase());
}

export function humanizeCondition(condition, { places = [] } = {}) {
  if (!condition) return "";

  const { type, params = {} } = condition;

  switch (type) {
    /* ===============================
       ⏰ HORARIO
    =============================== */
    case "TIME_RANGE": {
      const { start, end, crosses_midnight } = params;

      if (!start || !end) return "Horario no definido.";

      return crosses_midnight
        ? `Aplica desde las ${start} hasta las ${end} del día siguiente`
        : `Aplica desde las ${start} hasta las ${end}`;
    }

    /* ===============================
       📅 DÍAS
    =============================== */
    case "DAY_KIND": {
      const days = params.days || [];
      const holidays =
        params.holidays ?? params.include_holidays ?? false;

      if (!days.length && !holidays) {
        return "Sin días ni festivos definidos.";
      }

      const parts = [];

      if (days.length) {
        const names = days.map((d) => WEEK_DAYS[d]).join(", ");
        parts.push(names);
      }

      if (holidays) {
        parts.push("festivos");
      }

      return `Aplica ${parts.join(" y ")}`;
    }

    /* ===============================
       🚫 EXCEPCIÓN
    =============================== */
    case "EXEMPTION": {
      let placeType;
      let placeValue;

      // 🔁 FORMATO NUEVO (runtime)
      if (params.if_origin) {
        placeType = "ORIGIN";
        placeValue = params.if_origin;
      } else if (params.if_destination) {
        placeType = "DESTINATION";
        placeValue = params.if_destination;
      } else if (params.if_point) {
        placeType = "POINT";
        placeValue = params.if_point;
      } else if (params.if_zone) {
        placeType = "ZONE";
        placeValue = params.if_zone;
      }

      // 🔁 FORMATO UI (wizard)
      if (!placeType && params.place_type && params.place_value) {
        placeType = params.place_type;
        placeValue = params.place_value;
      }

      const exemptConcept = params.exempt_concept;

      if (!placeType || !placeValue || !exemptConcept) {
        return "Excepción incompleta.";
      }

      const place = places.find(
        (p) => (p.code || p.name) === placeValue
      );

      const placeLabel = place?.name ?? placeValue;

      const placeTypeLabel = {
        ORIGIN: "origen",
        DESTINATION: "destino",
        POINT: "origen o destino",
        ZONE: "zona",
      }[placeType] ?? placeType.toLowerCase();

      if (placeType === "ZONE") {
        return `No se aplica ${humanizeName(
          exemptConcept
        )} cuando el recorrido atraviesa la zona ${placeLabel}`;
      }

      return `No se aplica ${humanizeName(
        exemptConcept
      )} cuando el ${placeTypeLabel} es ${placeLabel}`;
    }

    default:
      return "Condición no reconocida.";
  }
}
